import React from "react";
import PropTypes from "prop-types";
import Modal from "shared/components/modal/Modal";
import PrimaryButton from "shared/components/form-elements/PrimaryButton";
import styles from "./styles.module.scss";
import downloadIcon from "../../../images/download-icon.svg";

class BillingHistory extends React.Component {
    componentDidUpdate(prevProps) {
        if (moduleHasLoaded(prevProps.invoices, this.props.invoices) && isAnchorModule()) {
            scrollToModule();
        }
    }

    render() {
        const {
            invoices,
            onDownloadInvoice,
            clearDownloadError,
            hasFileDownloadError
        } = this.props;

        if (!Array.isArray(invoices) || invoices.length === 0) {
            return null;
        }

        return (
            <div id="billing-history" className={ styles.billingHistory }>
                <h1 className={ styles.billingHistoryHeader }>Billing History</h1>
                <div>
                    <div className={ styles.billingHistoryColumnHeadersWrap }>
                        <div className={ `${ styles.billingHistoryCell } ${ styles.billingHistoryCellInvoiceDate }` }>Invoice Date</div>
                        <div className={ `${ styles.billingHistoryCell } ${ styles.billingHistoryCellReferenceId }` }>Reference Id</div>
                        <div className={ `${ styles.billingHistoryCell } ${ styles.billingHistoryCellAmount }` }>Amount</div>
                        <div className={ `${ styles.billingHistoryCell } ${ styles.billingHistoryCellDownload }` } />
                    </div>

                    { invoices.map((invoice) => (
                        <InvoiceRow
                            key={ invoice.id }
                            invoice={ invoice }
                            onDownloadInvoice={ onDownloadInvoice }
                        />
                    )) }
                </div>
                <ErrorModal isOpen={ hasFileDownloadError } onClick={ clearDownloadError } />
            </div>
        );
    }
}

const ErrorModal = ({ isOpen, onClick }) => {
    return (
        <Modal isOpen={ isOpen } isClosable={ false }>
            <div className={ styles.modalMessage }>Unable to download the requested invoice. Please try again.</div>
            <PrimaryButton onClick={ onClick } text="Ok" />
        </Modal>
    );
};

const InvoiceRow = ({ invoice, onDownloadInvoice }) => {
    const desktopDownloadLink = (
        <button
            className={ styles.billingHistoryDesktopDownloadLink }
            type="button"
            onClick={ (e) => onDownloadInvoice(e, invoice) }
            download={ true }
        >
            Download
        </button>
    );
    const mobileDownloadLink = (
        <button
            className={ styles.billingHistoryMobileDownloadLink }
            type="button"
            onClick={ (e) => onDownloadInvoice(e, invoice) }
        >
            <img className={ styles.billingHistoryDownloadIcon } src={ downloadIcon } alt="Download" />
        </button>
    );

    return (
        <div className={ styles.billingHistoryInvoiceRowWrap } key={ invoice.id }>
            <div className={ `${ styles.billingHistoryCell } ${ styles.billingHistoryCellInvoiceDate }` }>{ invoice.invoiceDate }</div>
            <div className={ `${ styles.billingHistoryCell } ${ styles.billingHistoryCellReferenceId }` }>{ invoice.invoiceNumber }</div>
            <div className={ `${ styles.billingHistoryCell } ${ styles.billingHistoryCellAmount }` }>${ invoice.amount }</div>
            <div className={ `${ styles.billingHistoryCell } ${ styles.billingHistoryCellDownload }` }>{ desktopDownloadLink } { mobileDownloadLink }</div>
        </div>
    );
};

function isAnchorModule() {
    return window.location.href.indexOf("anchor_module=billing-history") >= 0;
}

function moduleHasLoaded(prevInvoices, invoices) {
    return prevInvoices.length === 0 && invoices.length > 0;
}

function scrollToModule() {
    document.querySelector("#billing-history").scrollIntoView();
}

BillingHistory.propTypes = {
    invoices: PropTypes.arrayOf(PropTypes.shape({
        invoiceDate: PropTypes.string,
        invoiceNumber: PropTypes.string,
        id: PropTypes.string,
        amount: PropTypes.number
    })),
    onDownloadInvoice: PropTypes.func,
    clearDownloadError: PropTypes.func,
    hasFileDownloadError: PropTypes.bool
};

export default BillingHistory;
